import {Injectable} from '@angular/core';
import {ProductListing} from 'src/app/raintree/interface/product-listing/product-listing';
import {NormalFilterItem} from '../interface/normal-filter-item';
import {ColorFilterItem} from '../interface/color-filter-item';
import {RangeFilterItem} from '../interface/range-filter-item';
import {SegmentCategoryControl} from "../interface/segment-category-control";
import {SubCategoryControls} from "../interface/sub-category-controls";

@Injectable({
    providedIn: 'root'
})
export class FabricPreparationService {
    constructor() {
    }

    public getNestedFilterItems(
        previews: ProductListing[]
    ): SegmentCategoryControl[] {

        let segmentCategory: SegmentCategoryControl[] = [];
        previews.forEach((product: ProductListing): void => {

            segmentCategory.push({
                name: product.product.segment.name,
                key: 'segment',
                activated: false,
                options: []
            })
        });

        segmentCategory = [...new Map(segmentCategory.map( // for unique value
            (item: SegmentCategoryControl) => [item['name'], item])
        ).values()]


        segmentCategory.forEach((segItem: SegmentCategoryControl, i: number): void => {

            previews.forEach((product: ProductListing): void => {

                if (segItem.name === product.product.segment.name) {

                    segmentCategory[i].options.push({
                        name: product.product.subCategory.name,
                        activated: false
                    })
                }

            });

            segmentCategory[i].options = [...new Map(segmentCategory[i].options.map( // for unique value
                (item: SubCategoryControls) => [item['name'], item])
            ).values()]
        });
        // debugger
        return segmentCategory
    }

    public getUniqueFilterItems(
        key: string,
        previews: ProductListing[]
    ): NormalFilterItem[] {
        // TODO: this is only for product level. Later might add for fabric level as well
        let values: string[] = [];
        previews.forEach((preview: ProductListing): void => {

            if (key == 'category') {
                let value = [preview.product[key]]
                values = [...values, ...value.map((element: any) => element.name)];
            } else {
                if (preview.product[key]) {
                    // TODO: preprocess values as they are list
                    values = [...values, ...preview.product[key].map((element: any) => element.name)];
                }
            }

        });

        return values.filter(
            (value: string, index: number, self: string[]): boolean => {
                return self.indexOf(value) === index
            }
        ).map((element: string): NormalFilterItem => {
            return {name: element, activated: false}
        });
    };

    public getColorFilterItems(
        key: string,
        previews: ProductListing[]
    ): ColorFilterItem[] {

        let values: string[] = [];
        previews.forEach((preview: ProductListing): void => {

            if (preview.product[key]) {
                // TODO: preprocess values as they are list
                values = [...values, ...preview.product[key].map((element: any) => element.hex + element.name)];
            }
        });

        return values.filter(
            (value: string, index: number, self: string[]): boolean => {
                return self.indexOf(value) === index
            }
        ).map((element: string): ColorFilterItem => {
            return {
                name: element.slice(7,),
                colorCode: element.slice(0, 7),
                activated: false
            }
        });
    }

    public getRangeFilterItems(
        key: string,
        previews: ProductListing[],
        product: boolean = true
    ): RangeFilterItem {

        let values: number[] = [];

        if (product) {

            values = previews.map(
                (element: ProductListing) => Number(element.product[key])
            );
        } else {

            values = previews.map((element: ProductListing) => Number(element[key]));
        }

        return {
            min: 0,
            max: Math.max(...values),
            value1: 0,
            value2: Math.max(...values),
            defaultMin: Math.min(...values),
            defaultMax: Math.max(...values),

            // min: Math.min(...values),
            // max: Math.max(...values),
            // value1: Math.min(...values),
            // value2: Math.max(...values)
        };
    }


    public getAvailabilityControls(
        previews: ProductListing[]
    ): boolean {

        let value = false;
        previews.forEach((elm: ProductListing) => {
            if (elm.product.totalQuantity > 0) value = false
        })

        return value
    }
}
